import { Col, Row } from 'antd';
import classNames from 'classnames';
import { get } from 'lodash-es';
import { FormattedMessage } from 'react-intl';

import { PackageListCardTitle } from './packageListCommon';
import { usePackageListCommonStyles } from './packageListCommon.styles';
import { formatShipmentActualWeight } from '../../../containers/shipmentDetail/shipmentFormats';
import { LengthFormat } from '../../../components/domainSpecific/measuringUnitsElements';
import Whitespace from '../../../components/Whitespace';
import {
  DimensionalWeightValue,
  PreviewLabelWithValue,
} from './PackageListPackagePreviewMode';
import IconButton from '../../../components/buttons/IconButton';
import { DoubleLine } from '../../../components/layout/layoutElements';
import { formatCodeValue } from '../../../common/utils/formatUtils';
import { useQuotePackagesPreviewModeStyles } from './QuotePackagesPreviewMode.styles';

function DimensionalWeight({ value, className, valueClassName }) {
  const { styles } = usePackageListCommonStyles();
  return (
    <span
      className={classNames(
        'NewShipmentPackage-BilledWeight',
        styles.newShipmentPackageBilledWeight,
        className
      )}
    >
      <span className="text-uppercase">
        <FormattedMessage id="book.newShipment.packages.dimensionalWeight" />
      </span>
      <Whitespace />
      =<Whitespace />
      <span
        className={classNames(
          'NewShipmentPackage-BilledWeightValue',
          valueClassName
        )}
      >
        <DimensionalWeightValue value={value} />
      </span>
    </span>
  );
}

function DimensionalWeightTitle({
  value,
  billedWeightClassName,
  billedWeightValueClassName,
}) {
  return (
    <div>
      <div style={{ display: ' flex' }}>
        <DimensionalWeight
          value={value}
          className={billedWeightClassName}
          valueClassName={billedWeightValueClassName}
        />
      </div>
    </div>
  );
}

export function QuotePackagesPreviewMode({
  index,
  value,
  startEditing,
  remove,
  viewMode = false,
  headerClassName,
  bodyClassName,
  billedWeightClassName,
  billedWeightValueClassName,
}) {
  const { styles } = usePackageListCommonStyles();
  const { styles: previewModeStyles } = useQuotePackagesPreviewModeStyles();
  return (
    <div>
      <Row
        align="middle"
        justify="space-between"
        className={classNames(
          'new-quote-package-header',
          previewModeStyles.newQuotePackageHeader,
          headerClassName
        )}
      >
        <Col>
          <FormattedMessage
            id="book.newQuote.packageItemHeaderWithNumber"
            values={{ index: index + 1 }}
          />
        </Col>
        {!viewMode && (
          <Col>
            <div className={previewModeStyles.newQuotePackageControlButtons}>
              <IconButton
                className="icon-16"
                icon="edit"
                onClick={startEditing}
                titleId="buttons.edit"
              />
              <IconButton
                className="icon-16"
                icon="trash-alt"
                onClick={remove}
                titleId="buttons.delete"
              />
            </div>
          </Col>
        )}
      </Row>
      <div
        className={classNames(
          'NewShipmentPackage-PreviewBody',
          styles.newShipmentPackagePreviewBody,
          bodyClassName
        )}
      >
        <Row>
          <Col md={7} xs={12} lg={12}>
            <PreviewLabelWithValue
              labelId="book.newShipment.label.packageSource"
              text={formatCodeValue(value?.packageSource)}
            />
          </Col>
          <Col md={7} xs={12} lg={12}>
            <PreviewLabelWithValue
              labelId="book.newShipment.label.packagingType"
              text={formatCodeValue(value?.packagingType)}
            />
          </Col>
        </Row>
        <DoubleLine />
        <PackageListCardTitle
          text={
            <DimensionalWeightTitle
              value={value}
              startEditing={startEditing}
              remove={remove}
              viewMode={viewMode}
              billedWeightClassName={billedWeightClassName}
              billedWeightValueClassName={billedWeightValueClassName}
            />
          }
        />
        <Row>
          <Col span={7}>
            <PreviewLabelWithValue
              labelId="book.newShipment.label.actualWeight"
              text={formatShipmentActualWeight(value)}
            />
          </Col>
          <Col span={7}>
            <PreviewLabelWithValue
              labelId="book.newShipment.label.length"
              text={<LengthFormat value={get(value, 'length')} />}
            />
          </Col>
          <Col span={7}>
            <PreviewLabelWithValue
              labelId="book.newShipment.label.width"
              text={<LengthFormat value={get(value, 'width')} />}
            />
          </Col>
          <Col span={3}>
            <PreviewLabelWithValue
              labelId="book.newShipment.label.height"
              text={<LengthFormat value={get(value, 'height')} />}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
}
